module.exports = __webpack_public_path__ + "static/media/enterprise.743c895b.png";